<div class="select-assets">
    <div class="select-assets__header">
        <div>
            <h3 class="text-base--primary">Assets</h3>
            <p class="text-description">
                Select assets or channel you wish to add to your playlist
            </p>
        </div>
        <app-searchbar (searchTriggered)="searchTerm.set($event)" />
    </div>

    @if (showTabs()) {
        <app-add-content-tabs
            [tabs]="tabs()"
            [currentTab]="currentTab()"
            (tabClick)="onTabClick($event)" />
    }

    <div class="select-assets__contents" (scroll)="onScroll($event)">
        @if (isLoadingContents() && page() === 1) {
            <div class="select-assets__loading">
                <div class="select-assets__loader"></div>
                <p class="text-sm text-gray-500 font-medium">Loading assets...</p>
            </div>
        } @else if (contents().length > 0) {
            <div class="select-assets__content--assets grid-contents grid-contents--5">
                @for (content of contents(); track content.contentId) {
                    <div
                        class="ntv-thumbnail-item--wrapper"
                        [class.selected]="selectedIds().has(content.contentId)">
                        <ntv-thumbnail-item
                            [disableRightClick]="true"
                            [item]="content"
                            [selectedIds]="selectedIds()"
                            [selected]="selectedIds().has(content.contentId)"
                            size="md"
                            [customWidth]="'100%'"
                            [customTextSize]="'12px'"
                            [selectable]="!isPendingConversion(content)"
                            [showActionButtons]="false"
                            [eyeIconVisible]="false"
                            [showThumbnailInfoTag]="false"
                            [class.conversion-pending]="isPendingConversion(content)"
                            (selectionToggle)="onSelectionToggle(content.contentId)" />
                    </div>
                }
            </div>

            @if (isScrolling()) {
                <div class="flex items-center justify-center py-6">
                    <div
                        class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary-main"></div>
                </div>
            }
        } @else {
            <div class="select-assets__empty">
                <svg class="text-gray-300 mb-4" width="48" height="48">
                    <use xlink:href="assets/icons/icons-sprite.svg#images"></use>
                </svg>
                <h4 class="text-gray-900 font-semibold">No assets found</h4>
                <p class="text-gray-500 text-sm mt-1">
                    Try selecting a different tab or checking your library.
                </p>
            </div>
        }
    </div>
</div>
